<template>
  <div class="common-page order-review">
    <!--    <div class="line-separate"></div>-->
    <div class="right-box">
      <div class="content-box2">
        <div class="right-top">
          <custom-tab-box
            class="tab-box"
            :selectTab="selectTab"
            :tab-data="tabData"
            @change="handleChange"></custom-tab-box>
          <el-input
            class="right-search"
            style="width: 100%"
            clearable
            @input="handleChangeDriverSearch"
            v-model="diverOption.param.keyword"
            autocomplete="off"
            suffix-icon="el-icon-search"
            placeholder="请输入司机姓名和手机号"></el-input>
          <div class="search-2">
            <el-select
              v-model="diverOption.param.reportStatus"
              filterable
              allow-create
              @change="handleChangeDriverSearch"
              default-first-option
              clearable
              placeholder="请选择司机状态">
              <el-option
                v-for="item in $dict.reportStatusOptions"
                :key="item.dictCode"
                :label="item.dictLabel"
                :value="item.dictCode"></el-option>
            </el-select>
            <div class="driver-radio">
              <el-radio-group @change="handleChangeRadio" v-model="diverOption.param.mine">
                <el-radio :label="true">我的司机</el-radio>
                <el-radio :label="false">全部司机</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="right-center-box" v-loading="diverLoading">
          <template v-if="driverList && driverList.length > 0">
            <div
              class="center-box"
              v-for="(item, index) in driverList"
              :key="item.driverId"
              @click="handleSelectDriver(item)"
              :class="item.driverId === selectDriverId ? 'selectTab' : ''">
              <!--              :class="item.driverId === selectDriverId ? 'selectTab' : ''">-->
              <div v-if="!diverOption.param.mine">
                <div class="label-box label-box1" v-if="item.reportStatus === 0">未上报</div>
                <div class="label-box label-box2" v-if="item.reportStatus === 2">配满发车</div>
                <div class="label-box label-box3" v-if="item.reportStatus === 1">接单中</div>
              </div>
              <div v-else style="cursor: pointer">
                <el-popover placement="bottom" width="50" trigger="hover">
                  <!--                  <div class="select-status-list status1" @click="selectStatus(0, item, '未上报')">未上报</div>-->
                  <div class="select-status-list status2" @click="selectStatus(2, item, '配满发车')">配满发车</div>
                  <div class="select-status-list status3" @click="selectStatus(1, item, '接单中')">接单中</div>
                  <template slot="reference">
                    <div class="label-box label-box1" v-if="item.reportStatus === 0">未上报</div>
                    <div class="label-box label-box2" v-if="item.reportStatus === 2">配满发车</div>
                    <div class="label-box label-box3" v-if="item.reportStatus === 1">接单中</div>
                  </template>
                </el-popover>
              </div>
              <!--              <div class="label-box label-box1" v-if="item.reportStatus === 3">休息中</div>-->
              <div class="center-box-name">
                <div class="left-box">
                  <div class="center-box-1">
                    <span class="label-name" v-if="item.invoiceQualification">
                      票
                      <!--                      {{ item.username.substring(0, 1) }}-->
                    </span>
                    <span class="center-name" @click="checkDriver(item)">{{ item.username }}</span>
                  </div>
                  <div class="center-box-2">{{ item.companyName }}</div>

                  <div class="center-box-2">{{ item.carNumber }}</div>
                  <template v-if="item.lineType === 1">
                    <div class="center-box-2" v-if="item.reportStatus === 1 || item.reportStatus === 3">
                      {{ item.startCityName }}->{{ item.endCityName }}
                    </div>
                  </template>
                </div>
              </div>
              <div class="center-box-car">
                <div class="car-list">
                  <span @click="checkOrder(item)" class="number-list">
                    <span class="center-box-2">今日：派单{{ item.totalOrderNum }}</span>
                    <span class="center-box-2">成交{{ item.completeNum }}</span>
                    <span class="center-box-2">取消{{ item.cancelOrderNum }}</span>
                    <span class="center-box-2">总收入{{ item.totalFee }}</span>
                  </span>
                </div>

                <div class="car-list">
                  <div class="center-box-2">上报时间：{{ item.reportTime }}</div>
                  <div class="center-box-2">
                    剩余容量：
                    <span class="color52C41A">
                      {{ item.marginVolume<0?0:item.marginVolume }}方/{{ item.marginWeight<0?0:item.marginWeight }}吨
                    </span>
                  </div>
                </div>
              </div>
              <!--              v-if="item.reportStatus === 0 || item.reportStatus === 2"-->
              <!--              <div class="car-operate">-->
              <!--                <div class="operate-list" style="cursor: auto">-->
              <!--                  <span class="operate-txt color526bec" v-if="item.lat">*距装货点 {{item.distanceText}}</span>-->
              <!--                  <span class="operate-txt" v-else>无法计算距离</span>-->
              <!--                </div>-->
              <!--                <div class="operate-list" @click="handleCeSuan(item)">-->
              <!--                  <el-image :src="require('@/assets/imgs/dh.png')" class="operate-img"></el-image>-->
              <!--                  <span class="operate-txt">导航测算</span>-->
              <!--                </div>-->
              <!--                <div class="operate-line" v-if="item.reportStatus === 0 || item.reportStatus === 2"></div>-->
              <!--                <div class="operate-list" @click="handlePaiDan(item)">-->
              <!--                  <el-image :src="require('@/assets/imgs/pd.png')" class="operate-img"></el-image>-->
              <!--                  <span class="operate-txt">派单</span>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </template>
          <div class="no-data" v-else>
            <div
              style="display: flex;flex-direction: column;align-items: center"
              v-if="selectDriverLabel === 'myDriver' && diverOption.param.mine">
              <el-empty :image-size="100" description="今日暂未认领司机"></el-empty>
              <el-button type="primary" @click="addDriver()">认领司机</el-button>
            </div>

            <el-empty :image-size="100" description="暂无司机信息" v-else></el-empty>
          </div>
        </div>
        <div class="right-bottom-operate pagination-box">
          <el-pagination
            @size-change="handleDriverSizeChange"
            @current-change="handleDriverCurrentChange"
            :current-page="diverOption.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="diverOption.pageSize"
            background
            layout="total, prev, pager, next"
            :total="diverOption.total" />
        </div>
      </div>
    </div>
    <div class="left-box-content" v-if="selectDriverId">
      <div class="content-box1">
        <div class="search-form-box">
          <el-row :gutter="20">
            <el-form inline>
              <!--                            <el-col :span="6">-->
              <!--                              <el-form-item label="装货地:">-->
              <!--                                <custom-city-cascader-->
              <!--                                  :clearable="false"-->
              <!--                                  :disabled="true"-->
              <!--                                  :province-code="searchForm.loadProvinceCode"-->
              <!--                                  :city-code="searchForm.loadCityCode"-->
              <!--                                  :district-code="searchForm.loadDistrictCode"-->
              <!--                                  @update:provinceCode="-->
              <!--                                    (val) => (searchForm.loadProvinceCode = val)-->
              <!--                                  "-->
              <!--                                  @update:cityCode="(val) => (searchForm.loadCityCode = val)"-->
              <!--                                  @update:districtCode="-->
              <!--                                    (val) => (searchForm.loadDistrictCode = val)-->
              <!--                                  "></custom-city-cascader>-->
              <!--                              </el-form-item>-->
              <!--                            </el-col>-->
              <!--                            <el-col :span="6">-->
              <!--                              <el-form-item label="卸货地:">-->
              <!--                                <custom-city-cascader-->
              <!--                                  :clearable="false"-->
              <!--                                  :disabled="true"-->
              <!--                                  :province-code="searchForm.unloadProvinceCode"-->
              <!--                                  :city-code="searchForm.unloadCityCode"-->
              <!--                                  :district-code="searchForm.unloadDistrictCode"-->
              <!--                                  @update:provinceCode="-->
              <!--                                    (val) => (searchForm.unloadProvinceCode = val)-->
              <!--                                  "-->
              <!--                                  @update:cityCode="-->
              <!--                                    (val) => (searchForm.unloadCityCode = val)-->
              <!--                                  "-->
              <!--                                  @update:districtCode="-->
              <!--                                    (val) => (searchForm.unloadDistrictCode = val)-->
              <!--                                  "></custom-city-cascader>-->
              <!--                              </el-form-item>-->
              <!--                            </el-col>-->
              <el-col :span="7">
                <el-form-item label="下单时间:">
                  <custom-date-range
                    :start-date="searchForm.createTimeStart"
                    :end-date="searchForm.createTimeEnd"
                    @update:startDate="
                      (val) => (searchForm.createTimeStart = val)
                    "
                    @update:endDate="(val) => (searchForm.createTimeEnd = val)"></custom-date-range>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="">
                  <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                  <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div
          class="custom-table-box"
          v-loading="tableOptions.loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.8)">
          <template v-if="tableData && tableData.length">
            <div
              class="table-list"
              :class="item.orderId === selectOrderId ? 'table-list-select' : ''"
              v-for="(item, index) in tableData"
              :key="item.orderId"
              @click="handleSelectOrder(item, index)">
              <div class="list-top">
                <div class="list-top-left">
                  <div class="left-box" v-for="(item2, index) in item.pointList" :key="index">
                    <div class="left-box-top">
                      <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                        {{ item2.loadType === 1 ? "装" : "卸" }}
                      </div>
                      <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                    </div>
                  </div>
                </div>
                <div class="list-top-right">
                  <!--              <div class="right-money">-->
                  <!--                <span class="money">3000.00</span>-->
                  <!--                <span class="unit">元/趟</span>-->
                  <!--              </div>-->
                  <div class="right-money" v-if="item.driverCancel">
                    <span class="unit">司机取消订单，优先调度</span>
                  </div>
                  <div class="right-box2">
                    <div class="right-box2-time">
                      <span class="color526bec" v-if="item.distance !== null && item.distance >= 0">
                        *距装货点 {{item.distance< 0.1?'不足100m':item.distance+'Km'}}&nbsp;&nbsp;&nbsp;
                      </span>
                      <span v-else>无法计算距离&nbsp;&nbsp;&nbsp;</span>
                      <span>装货时间：{{ item.startLoadTime || '-' }}&nbsp;&nbsp;&nbsp;</span>
                      <span>下单时间：{{ item.createTime }}</span>
                      <span class="color1269FF cursor" @click="openDetail(item)">详情</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-bottom">
                <div class="list-bottom-box">
                  <div class="bottom-box-name">物品</div>
                  <div class="bottom-box-value">
                    {{ item.cargo.cargoName || "-" }}
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">重量</div>
                  <div class="bottom-box-value">
                    {{ item.cargo.weight || "-" }}
                    {{ item.cargo.wightUnit === 1 ? "吨" : "公斤" }}
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">体积</div>
                  <div class="bottom-box-value">{{ item.cargo.volume || "-" }}㎡</div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">包装方式</div>
                  <div class="bottom-box-value">
                    {{ item.cargo.packingWays || "-" }}
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">用车要求</div>
                  <div class="bottom-box-value">
                    {{ item.vehicleUseType || "-" }}
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">车型</div>
                  <div class="bottom-box-value">
                    <custom-tooltip-multiple :text="item.vehicle?.vehicleMode"></custom-tooltip-multiple>
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">车长</div>
                  <div class="bottom-box-value">
                    <custom-tooltip-multiple :text="item.vehicle?.vehicleLength"></custom-tooltip-multiple>
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">预估运费</div>
                  <div class="bottom-box-value">
                    <span class="money">{{ item.fee || "-" }}元</span>
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">备注</div>
                  <div class="bottom-box-value">
                    <!--                    <span>{{ item.remark || "-" }}</span>-->
                    <custom-tooltip :text="item.remark"></custom-tooltip>
                  </div>
                </div>
                <div class="list-bottom-box">
                  <div class="right-default" @click.stop="handleCeSuan(item)">导航测算</div>
                  <div class="right-primary" @click="handlePaiDan(item)">补仓</div>
                </div>
              </div>
            </div>
          </template>
          <div class="no-data" v-else>
            <el-empty :image-size="100" description="暂无订单"></el-empty>
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableOptions.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tableOptions.pageSize"
            background
            layout="total, prev, pager, next, sizes, jumper"
            :total="tableOptions.total" />
        </div>
      </div>
    </div>
    <div class="left-box-content left-box-content1" v-else>
      <el-empty :image-size="100" description="请点击左侧司机查询订单"></el-empty>
    </div>
    <detail ref="detail" @refresh="refreshData"></detail>
    <orderInfo ref="orderInfo"></orderInfo>
    <todayOrderDetail ref="todayOrderDetail"></todayOrderDetail>
    <addDriver ref="addDriver" @refreshMyDriverList="refreshMyDriverList"></addDriver>
    <driverDetail ref="driverDetail"></driverDetail>
  </div>
</template>

<script>
import driverDetail from "@/views/FleetLeaderWorkbench/PlatformDriverManagement/detail.vue"
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import { dispatchOrderToDriver, driverStatus, getDispatchOrderPage } from "../api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import CustomSortBox from "@/components/customComponents/CustomSortBox.vue";
import CustomCityCascader from "@/components/CustomCityCascader.vue";
import { getAreaNext, getDispatchDriver } from "@/views/commonApi";
import customTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import { debounce } from "lodash";
import Detail from "@/views/OrderManagement/detail.vue";
import orderInfo from "../orderInfo.vue";
import addDriver from "../addDriver.vue";
import todayOrderDetail from "@/views/FleetLeaderWorkbench/RealtimeMonitoring/components/todayOrderDetail.vue";
export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    driverDetail,
    todayOrderDetail,
    addDriver,
    orderInfo,
    Detail,
    CustomTabBox,
    CustomSortBox,
    CustomCityCascader,
    customTooltipMultiple,
    CustomTooltip,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      tableOptions: {
        loading: false,
        currentPage: 1,
        pageCount: 0,
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
      diverLoading: false,
      sortData: [
        // {
        //   name: "派单量",
        //   key: "pdl",
        //   value: "",
        // },
        {
          name: "上报时间",
          key: "sbsj",
          value: "",
        },
      ],
      loading: false,
      cheImage: require("@/assets/imgs/title.png"),
      selectTab: 2,
      selectDriverLabel: "myDriver",
      isOver: false,
      tabData: [
        {
          label: 1,
          value: "订单找车",
        },
        {
          label: 2,
          value: "车辆补仓",
        },
      ],
      cityProps: {
        lazy: true,
        checkStrictly: true, //可选择任意节点
        lazyLoad(node, resolve) {
          // setTimeout(() => {
          const nodes = [];
          let query = {};
          // 构造查询条件
          if (node.value) {
            query = {
              code: node.value,
            };
          }
          //查询接口
          getAreaNext(query).then((res) => {
            res.data.map((item) => {
              let obj = {
                value: item.areaCode,
                label: item.areaName,
                leaf: item.areaLevel === 2,
                // disabled: item.areaLevel <= 1,
              };
              nodes.push(obj);
            });
            //重新加载节点
            resolve(nodes);
          });
          // }, 500);
        },
      },
      getTableMethod: getDispatchOrderPage,
      searchForm: {
        createTimeStart: "",
        createTimeEnd: "",
        loadCityCode: "",
        loadDistrictCode: "",
        loadProvinceCode: "",
        unloadCityCode: "",
        unloadDistrictCode: "",
        unloadProvinceCode: "",
        driverId: ""
      },
      driverList: [], // 调度人员列表
      isImmediatelyGetData: false,
      dispatchLoading: false, // 指派loading
      selectOrderId: "",
      selectDriverId: "",
      selectDriverItem: {},
      diverOption: {
        currentPage: 1,
        pageSize: 10,
        pageCount: 0,
        total: 0,
        param: {
          keyword: "",
          cover: true,
          mine: true,
          reportStatus: "",
        },
      },
    };
  },
  // watch: {
  //   selectDriverId: function (val) {
  //     if (!val) {
  //       this.searchForm.loadProvinceCode = "";
  //       this.searchForm.loadCityCode = "";
  //       this.searchForm.unloadProvinceCode = "";
  //       this.searchForm.unloadCityCode = "";
  //       this.searchForm.createTimeEnd = "";
  //       this.searchForm.createTimeStart = "";
  //       this.tableOptions.currentPage = 1
  //       this.getTableData();
  //     }
  //   }
  // },
  created() {},
  mounted() {
    this.getPingTaiDriver();
  },
  methods: {
    checkDriver(item) {
      this.$refs.driverDetail.init("司机详情", true, item, "examine");
    },
    addDriver() {
      this.$refs.addDriver.init()
    },
    refreshMyDriverList() {
      this.getPingTaiDriver();
    },
    refreshData() {
      this.selectOrderId = ""
      this.diverOption.currentPage = 1;
      this.getTableData()
    },
    handleReset() {
      this.searchForm.createTimeEnd = "";
      this.searchForm.createTimeStart = "";
      this.searchPage();
    },
    checkOrder(row) {
      this.$refs.todayOrderDetail.init(row.driverId, row.username);
      // if (row.currentOrder > 0) {
      //   this.$refs.orderInfo.init(row);
      // } else {
      //   this.$message.error("当前无订单");
      // }
    },
    resetData() {
      this.selectDriverId = ""
      this.searchForm.createTimeEnd = "";
      this.searchForm.createTimeStart = "";
      this.tableData = []
      this.diverOption.currentPage = 1;
    },
    handleChangeRadio(val) {
      this.resetData()
      this.getPingTaiDriver();
    },
    handleSelectDriver(item) {
      this.selectDriverId = item.driverId;
      if (item.lineType === 1) {
        this.searchForm.loadProvinceCode = item.startProvinceCode;
        this.searchForm.loadCityCode = item.startCityCode;
        this.searchForm.unloadProvinceCode = item.endProvinceCode;
        this.searchForm.unloadCityCode = item.endCityCode;
        this.searchForm.driverId = item.driverId;
        this.tableOptions.currentPage = 1
        this.getTableData();
      } else {
        this.searchForm.loadProvinceCode = "";
        this.searchForm.loadCityCode = "";
        this.searchForm.unloadProvinceCode = "";
        this.searchForm.unloadCityCode = "";
      }
      this.selectDriverItem = item;
    },
    openDetail(item) {
      this.$refs.detail.init(item);
    },
    handleChangeDriverSearch: debounce(function (val) {
      this.resetData()
      this.getPingTaiDriver();
    }, 500),
    resetStatus() {
      // 订单列表
      // this.selectOrderId = "";
      this.tableOptions.currentPage = 1;
      this.getTableData();
      // 司机列表
      this.getPingTaiDriver();
    },

    // 订单操作
    handleChange(val) {
      this.selectTab = val;
      this.$emit("changeTab", this.selectTab);
    },
    handleSizeChange(val) {
      this.tableOptions.currentPage = 1;
      this.tableOptions.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.tableOptions.currentPage = val;

      this.getTableData();
    },
    // 司机操作
    handleDriverSizeChange(val) {
      this.diverOption.currentPage = 1;
      this.diverOption.pageSize = val;
      this.getPingTaiDriver();
    },
    handleDriverCurrentChange(val) {
      this.diverOption.currentPage = val;
      this.getPingTaiDriver();
    },
    getPingTaiDriver() {
      this.diverLoading = true;
      getDispatchDriver(this.diverOption)
        .then((res) => {
          if (res.code === 200) {
            if (
              this.diverOption.currentPage > 1 &&
              (res.data === undefined || res.data.data.length === 0)
            ) {
              this.diverOption.currentPage--;
              this.getPingTaiDriver();
              return;
            }
            this.driverList = res.data.data;
            this.diverOption.total = res.data.totalCount;
            this.diverOption.pageCount = res.data.totalPage;
          }
        })
        .finally(() => {
          this.diverLoading = false;
        });
    },
    handleCeSuan(item) {
      this.selectOrderId = item.orderId;
      if (!this.selectDriverId) {
        this.$message.warning("请选择司机！");
        return;
      }
      this.$emit("ceSuan", {
        order: item,
        driver: this.selectDriverItem,
      });
    },
    // 派单
    handlePaiDan(item) {
      this.selectOrderId = item.orderId;
      if (!this.selectDriverId) {
        this.$message.warning("请选择司机！");
        return;
      }
      this.dispatchLoading = true;
      this.$confirm(`确定派单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        dispatchOrderToDriver({
          driverId: this.selectDriverId,
          orderId: item.orderId,
        })
          .then((res) => {
            this.dispatchLoading = false;
            if (res.code === 200) {
              this.$message.success("补仓成功");
              this.resetStatus();
            }
          })
          .finally(() => {
            this.dispatchLoading = false;
          });
      });
    },
    selectTabDriver(val) {
      this.selectDriverLabel = val;
    },

    handleSelectOrder(item) {
      this.selectOrderId = item.orderId;
    },
    selectStatus(status, item, txt) {
      this.$confirm(`确定修改为 ${txt} ？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.diverLoading = true;
        driverStatus({
          driverId: item.driverId,
          reportStatus: status,
        })
          .then((res) => {
            this.diverLoading = false;
            if (res.code === 200) {
              this.$message.success("修改成功");
              item.reportStatus = status
              // this.getPingTaiDriver();
            }
          })
          .finally(() => {
            this.diverLoading = false;
          });
      });
    },
    // handleLoadMore() {
    //   this.loading = true;
    //
    //   setTimeout(() => {
    //     this.loading = false;
    //     this.driverList = this.driverList.concat(this.driverList);
    //     this.isOver = true;
    //   }, 2000);
    // },
  },
};
</script>
<style lang="scss" scoped>
.order-review {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  .money {
    font-size: 0.18rem;
    color: #faad14;
  }

  .left-box-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.2rem;
    box-sizing: border-box;
    border-radius: 0.08rem;

    .custom-table-box {
      //max-height: 90%;
      overflow-y: auto;
      padding-top: 0;

      .table-list {
        width: 100%;
        background: #fbfcff;
        margin-bottom: 0.2rem;
        padding: 0.12rem 0.1rem;
        box-sizing: border-box;
        border: 0.01rem solid #fbfcff;
        border-radius: 0.08rem;
        cursor: pointer;
        .list-top {
          display: flex;
          justify-content: space-between;
          .list-top-left {
            display: flex;
            .left-box {
              padding-right: 0.35rem;
              position: relative;
              .left-box-top {
                display: flex;
                align-items: center;
                .label {
                  width: 0.2rem;
                  height: 0.2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.02rem;
                  font-size: 0.12rem;
                }
                .zhuang {
                  color: #5cc41a;
                  background-color: rgba(92, 196, 26, 0.3);
                }
                .xie {
                  color: #e52019;
                  background-color: rgba(229, 32, 25, 0.3);
                }
                .name {
                  color: #000000;
                  font-size: 0.16rem;
                  line-height: 0.2rem;
                  padding-left: 0.04rem;
                }
              }
              .date {
                color: #8c8c8c;
                font-size: 0.12rem;
                line-height: 0.2rem;
              }
            }
            .left-box::before {
              content: "→";
              position: absolute;
              right: 0.15rem;
              top: 0rem;
              font-size: 0.2rem;
              color: #52c41a;
            }
            .left-box:nth-last-of-type(1)::before {
              display: none;
            }
          }
          .list-top-right {
            position: relative;
            .right-money {
              display: flex;
              justify-content: right;
              align-items: baseline;
              color: #faad14;

              .unit {
                font-size: 0.12rem;
                padding-left: 0.04rem;
              }
            }
            .right-box2 {
              display: flex;
              align-items: center;
              .right-box2-time {
                font-size: 0.12rem;
                line-height: 0.2rem;
                color: #8c8c8c;
                margin-right: 0.1rem;
              }
              .right-box2-label {
                background-color: #fff7e6;
                color: #fa8c16;
                font-size: 0.12rem;
                line-height: 0.22rem;
                border-radius: 0.1rem;
                padding: 0 0.1rem;
              }
            }
          }
        }
        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.12rem 0;
          .list-bottom-box {
            width: 15%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .right-default {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #eaf1ff;
              color: #1269ff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
              //margin-bottom: 0.1rem;
              position: relative;
              top: -0.05rem;
            }
            .right-primary {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #1269ff;
              color: #ffffff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 0.1rem;
              position: relative;
              top: -0.05rem;
            }
            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.1rem;
            }
            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
              text-align: center;
            }
          }
          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.08rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }
          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }
        }
        .car-box {
          display: flex;
          align-items: center;
          border-top: 0.01rem dashed #dce5f5;
          padding: 0.1rem 0 0;
          .list-1 {
            display: flex;
            align-items: center;

            .label-img {
              width: 0.14rem;
              height: 0.14rem;
            }
            .center-name {
              line-height: 0.2rem;
              padding-left: 0.04rem;
              font-size: 0.14rem;
              color: #52c41a;
            }
          }
          .list-2,
          .list-3 {
            font-size: 0.12rem;
            color: #8c8c8c;
          }
          .list-2 {
            padding: 0 0.2rem;
            position: relative;
            &::before {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              left: 0.1rem;
            }
            &::after {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              right: 0.1rem;
            }
          }
        }
      }
      .table-list-select {
        border-color: #1269ff;
        background-color: rgba(18, 105, 255, 0.05);
      }
    }
    .pagination-box {
      display: flex;
      justify-content: right;
      padding: 0.2rem 0.2rem 0.2rem 0;
      background-color: #fff;
    }
  }
  .left-box-content1{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .line-separate {
    width: 0.01rem;
    height: calc(100% - 0.4rem);
    background-color: rgba(220, 229, 245, 0.5);
    box-sizing: border-box;
    margin: 0.2rem 0.2rem 0.2rem 0;
  }
  .right-box {
    width: 30%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    padding: 0.2rem 0rem 0.2rem 0.2rem;
    .right-top {
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      padding-top: 0.2rem;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-title-tip {
        color: rgba(0, 0, 0, 0.25);
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding: 0.1rem 0;
      }
      .right-search {
        margin: 0.15rem 0 0;
      }
      .search-2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.2rem;
      }
      .sort-car {
        padding: 0.1rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      padding-top: 0.2rem;
      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        overflow: hidden;
        position: relative;
        .label-box {
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 0 0 0.08rem;

          width: 0.79rem;
          height: 0.29rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.12rem;
        }
        .label-box1 {
          background: rgba(250, 173, 20, 0.15);
          color: #faad14;
        }
        .label-box2 {
          background: rgba(82, 196, 26, 0.15);
          color: #52c41a;
        }
        .label-box3 {
          background: rgba(18, 105, 255, 0.15);
          color: #1269ff;
        }
        .center-box-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.1rem 0;
          .left-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .center-box-1 {
              display: flex;
              align-items: center;
              .label-name {
                width: 0.3rem;
                height: 0.3rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1269ff;
                font-size: 0.14rem;
                background-color: rgba(18, 105, 255, 0.05);
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
                font-weight: bold;
                cursor: pointer;
                &:hover{
                  text-decoration: underline;
                }
              }
            }
            .center-box-2 {
              display: flex;
              align-items: center;
              line-height: 0.24rem;
              color: #000000;
              font-size: 0.12rem;
              position: relative;
            }
            .center-box-2 {
              padding-left: 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
            }
          }

          .center-box-3 {
            flex-shrink: 0;
            line-height: 0.2rem;
            font-size: 0.16rem;
            .default-icon {
              color: #eeeeee;
            }
            .selected-icon {
              color: #52c41a;
            }
          }
        }
        .center-box-car {
          border-top: 0.01rem dashed #dce5f5;
          .car-list {
            display: flex;
            align-items: center;
            padding: 0.08rem 0;
            .number-list{
              cursor: pointer;
              &:hover{
                text-decoration: underline;
                span{
                  color: #0a65f0;
                }

              }
            }
            .center-box-2 {
              padding-right: 0.2rem;
              color: #8c8c8c;
              position: relative;
              font-size: 0.12rem;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
                top: 0.02rem;
              }
            }
            .center-box-2:nth-last-of-type(1)::before {
              display: none;
            }
          }
        }
        .car-operate {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0.1rem 0;
          background-color: #f4f6fd;
          margin: 0 -0.1rem;
          .operate-list {
            display: flex;
            align-items: center;
            position: relative;
            width: 100%;
            height: 100%;
            justify-content: center;
            .operate-img {
              width: 0.14rem;
              height: 0.14rem;
              margin-right: 0.02rem;
            }
            .operate-txt {
              font-size: 0.12rem;
              color: #434343;
            }
          }
          .operate-line {
            width: 0.01rem;
            height: 0.14rem;
            background-color: #e3e7ed;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }
    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }
  }
  .tab-box {
    margin-bottom: 0.2rem;
  }
  .content-box1 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
  .content-box2 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 0 0.2rem;
    box-sizing: border-box;
  }
}
.select-status-list{
  font-size: 0.14rem;
  padding: 0.06rem 0;
  text-align: center;
  cursor: pointer;
  &:hover{
    cursor: pointer;
    text-decoration: underline;
  }
}
.status1 {
  background: rgba(250, 173, 20, 0.15);
  color: #faad14;
}
.status2 {
  background: rgba(82, 196, 26, 0.15);
  color: #52c41a;
}
.status3 {
  background: rgba(18, 105, 255, 0.15);
  color: #1269ff;
}
</style>
